import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const LootNode = memo(({ data, isConnectable }) => {
  const { label, lootId, hasChildren, isExpanded, rawData } = data;
  
  // Format the inventory operation line
  const formatInventoryOperation = () => {
    if (!rawData) return null;
    
    const operation = rawData.inventory_operation || '';
    const selectorType = rawData.inventory_selector_type || '';
    const quantity = rawData.quantity || '';
    
    if (!operation || !selectorType || !quantity) return null;
    
    return `${operation} ${selectorType} ${quantity}`;
  };
  
  const inventoryText = formatInventoryOperation();
  
  // Get active status emoji
  const getActiveEmoji = () => {
    if (rawData && typeof rawData.active === 'boolean') {
      return rawData.active ? '✅ ' : '❌ ';
    }
    return '';
  };
  
  return (
    <Box
      sx={{
        background: '#1565C0',
        color: 'white',
        padding: '8px 12px',
        borderRadius: 1,
        minWidth: 180,
        minHeight: 70,
        position: 'relative',
        cursor: hasChildren ? 'pointer' : 'default',
        '&:hover': {
          boxShadow: 2,
        },
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
        style={{ background: '#888', border: '2px solid #1565C0' }}
      />
      
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="caption" sx={{ 
            fontWeight: 'bold', 
            fontSize: '0.7rem',
            opacity: 0.9,
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            {getActiveEmoji()}LOOT
          </Typography>
          {label && label !== 'Loot' && (
            <>
              <Typography variant="caption" sx={{ 
                fontWeight: 'bold', 
                fontSize: '0.7rem',
                opacity: 0.9
              }}>
                -
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
                {label}
              </Typography>
            </>
          )}
          {hasChildren && (
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
              {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </Box>
          )}
        </Box>
        
        <Typography variant="caption" sx={{ opacity: 0.8, fontSize: '0.7rem' }}>
          {lootId}
        </Typography>
        
        {inventoryText && (
          <Typography variant="caption" sx={{ opacity: 0.8, fontSize: '0.7rem', fontWeight: 'medium' }}>
            {inventoryText}
          </Typography>
        )}
      </Box>
      
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        style={{ background: '#888', border: '2px solid #1565C0' }}
      />
      

    </Box>
  );
});

LootNode.displayName = 'LootNode';

export default LootNode; 